export const DEFAULT_NOTIFICATION_TIME_UP = 3_500;

export enum DefaultSnackbarMessage {
  SOMETHING_WENT_WRONG = 'Something went wrong',
}
